import { FluidObject } from 'gatsby-image';

import { AllImagesSharpQueryResponse } from '../interfaces/AllImagesSharpQueryResponse';

export function findImage(
  imageSrc: string,
  data: AllImagesSharpQueryResponse,
  key: 'fluid' | 'smallImage' | 'bigImage' = 'fluid',
): FluidObject | undefined {
  const img = data.allImageSharp.edges.find((edge) =>
    edge.node[key]?.src.endsWith('/' + imageSrc.split('/').slice(-1)[0]),
  );
  return img ? img.node[key] : data.default?.childImageSharp[key];
}
